import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { FileText, Download } from 'lucide-react';
import API from '../lib/api';

export default function DailyReportPage() {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/reports/daily?date=${date}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `informe_diario_${date}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="daily-report-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Informe Diario</h1>
        <p className="text-gray-500 mt-1 text-sm">Genera un PDF con el resumen de fichajes del dia</p>
      </div>

      <div className="bg-white border border-orange-100 rounded-xl p-6 max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
            <FileText className="w-6 h-6 text-orange-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Generar informe</h3>
            <p className="text-xs text-gray-500">Incluye fichajes, horas y firmas digitales</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider font-semibold text-gray-600">Fecha del informe</Label>
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="max-w-xs"
              data-testid="report-date-input"
            />
          </div>

          <Button
            onClick={handleDownload}
            disabled={loading}
            className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white rounded-lg shadow-md shadow-orange-200"
            data-testid="download-report-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            {loading ? 'Generando...' : 'Descargar PDF'}
          </Button>
        </div>
      </div>
    </div>
  );
}
